import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'

import sanitizeHtml from 'sanitize-html'

import DevicesWrapper from '../component/services/devices-wrapper'

// import { formatCurrency } from '../utils/functions'
import Package from '../component/services/package'
import PackageSuppl from '../component/services/package-suppl'
import PackageOther from '../component/services/package-other'

// import sanitizeHtml from 'sanitize-html'
import { renderError } from '../utils/form'
import { ParseContent, parseContent } from '../utils/functions'
import { ALLOWED_ATTRIBUTES, ALLOWED_TAGS } from '../conf/constants'

const UpsellListWrapper = ({ label, desc, children, type }) => {
  return (
    <React.Fragment>
      <h2 className="h2">
        <ParseContent
          ckey={label}
          filterHtml={true}
          allowedAttributes={[]}
          allowedTags={[]}
        />
      </h2>
      <p className={'services__subtitle'}>
        <ParseContent
          ckey={desc}
          filterHtml={true}
          allowedAttributes={[]}
          allowedTags={[]}
        />
      </p>
      <div className={type + ' offer-step--1'}>{children}</div>
    </React.Fragment>
  )
}

const PortfolioListWrapper = ({
  label,
  desc,
  labelActionText,
  labelTextAction,
  labelSuffix,
  descActionText,
  descTextAction,
  descSuffix,
  children,
}) => {
  return (
    <React.Fragment>
      <h2>
        {label} <u onClick={labelTextAction}>{labelActionText}</u>
        {labelSuffix}
      </h2>
      <p className={'portfolio__content__info'}>
        {desc} <u onClick={descTextAction}>{descActionText}</u>
        {descSuffix}
      </p>
    </React.Fragment>
  )
}

class ServiceUpsellFormUpsell extends Component {
  componentDidMount() {
    if (this.props.selectedPackageCore)
      this.props.change('package_core', this.props.selectedPackageCore)

    try {
      const option =
        this.props.options && this.props.options[this.props.selectedPortfolio]
      Object.values(option.other).forEach((o) => {
        if (o.required && o.selected) {
          this.props.change(`package_other[${o.group}]`, true)
        }
      })
    } catch (error) {}
  }

  render() {
    const {
      options,
      // portfolios,
      // resetUpsell,
      handleSubmit,
      handleServices,
      handleInstallation,
      handleSubmitStep1,
      submitting,
      toggleModal,
      // selectPortfolio,
      selectedPortfolio,
      selectedInstallation,
      // selectedPackageCore,
      content,
      change,
      contract,
      deviceTotal,
      formData,
    } = this.props

    let option
    let isUpsell

    try {
      if (Object.keys(options).includes('packages')) {
        option = options.packages || {
          core: {},
          suppl: {},
          other: {},
          device: {},
          installation: {},
          deviceMin: 0,
          deviceMax: 0,
        }
        isUpsell = true
      } else {
        option = options && selectedPortfolio && options[selectedPortfolio]
        isUpsell = false
      }
    } catch (error) {
      // console.error(error);
      option = {
        core: {},
        suppl: {},
        other: {},
        device: {},
        installation: {},
        deviceMin: 0,
        deviceMax: 0,
      }
    }
    // console.log(selectedPortfolio)

    let core
    let suppl
    let other
    let devices
    let installations

    try {
      core = Object.values(option.core).filter((i) => !i.private)
    } catch (error) {
      core = []
    }
    try {
      suppl = Object.values(option.suppl).filter((i) => !i.private)
    } catch (error) {
      suppl = []
    }
    try {
      other = Object.values(option.other).filter((i) => !i.private)
    } catch (error) {
      other = []
    }
    try {
      devices = Object.values(option.device).filter((i) => !i.private)
    } catch (error) {
      devices = []
    }
    try {
      installations = Object.values(option.installation)
    } catch (error) {
      installations = []
    }

    const portfolioKey = contract.portfolio.group

    return (
      <form onSubmit={handleSubmit(handleSubmitStep1)}>
        {core && (
          <UpsellListWrapper
            label={`content.${
              isUpsell ? 'upsell' : 'new'
            }.contract.${portfolioKey}.packages.title`}
            desc={`content.${
              isUpsell ? 'upsell' : 'new'
            }.contract.${portfolioKey}.packages.description`}
            type={'packages'}
          >
            <Field name="package_core" component={renderError} />
            {core.map((item) => (
              <Package
                isUpsell={true}
                key={item.group}
                item={item}
                toggleModal={toggleModal}
                tag={parseContent(
                  content[
                    `content.${
                      isUpsell ? 'upsell' : 'new'
                    }.contract.${portfolioKey}.${item.group}.tag`
                  ],
                  {
                    html: true,
                    allowedAttributes: [],
                    allowedTags: [],
                  }
                )}
                channelCount={parseContent(
                  content[
                    `content.${
                      isUpsell ? 'upsell' : 'new'
                    }.contract.${portfolioKey}.${item.group}.channel_count`
                  ],
                  {
                    html: true,
                    allowedAttributes: [],
                    allowedTags: [],
                  }
                )}
                channels={
                  content[
                    `content.${
                      isUpsell ? 'upsell' : 'new'
                    }.contract.${portfolioKey}.${item.group}.channels`
                  ]
                    ? sanitizeHtml(
                        content[
                          `content.${
                            isUpsell ? 'upsell' : 'new'
                          }.contract.${portfolioKey}.${item.group}.channels`
                        ],
                        {
                          // html: true,
                          allowedAttributes: ALLOWED_ATTRIBUTES,
                          allowedTags: ALLOWED_TAGS,
                        }
                      )
                    : null
                }
                selectPackage={() => {
                  handleServices(item.group, 'core')
                  change(`package_core`, item.group)
                }}
                // description={
                //   '<div class="channel__list"><h2>Všeobecné</h2><div><span><img alt="Telly" src="https://moje.telly.cz/img/channel-premier-sport-2-60.png"><span><strong>Premier Sport HD</strong></span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-1-3-60.png"><span>Digi Sport 1 HD</span></span> <span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-2-2-60.png"><span>Digi Sport 2 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-3-2-60.png"><span>Digi Sport 3 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-6-2-60.png"><span>Digi Sport 6 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-7-2-60.png"><span>Digi Sport 7 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-8-2-60.png"><span>Digi Sport 8 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-9-2-60.png"><span>Digi Sport 9 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-nova-sport-1-60.png"><span>Nova sport 1 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-nova-sport-2-60.png"><span>Nova sport 2 HD</span></span> <span><img alt="Telly" src="https://moje.telly.cz/img/channel-eurosport-1-3-60.png"><span>Eurosport 1 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-eurosport-2-3-60.png"><span>Eurosport 2 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-arena-sport-1-60.png"><span>Arena Sport 1 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-arena-sport-2-60.png"><span>Arena Sport 2 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-fightbox-60.png"><span>FightBox HD</span></span> <span><img alt="Telly" src="https://moje.telly.cz/img/channel-golf-60.png"><span>Golf Channel</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct-sport-60.png"><span>ČT sport HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct1-60.png"><span>ČT 1 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct2-60.png"><span>ČT 2 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct3-60.png"><span>ČT 3 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct24-60.png"><span>ČT 24 HD</span></span></div></div>'
                // }
                description={parseContent(
                  content[
                    `content.${
                      isUpsell ? 'upsell' : 'new'
                    }.contract.${portfolioKey}.${item.group}.description`
                  ],
                  {
                    html: true,
                    allowedTags: ALLOWED_TAGS,
                    allowedAttributes: ALLOWED_ATTRIBUTES,
                  }
                )}
              />
            ))}
          </UpsellListWrapper>
        )}

        {suppl && (
          <UpsellListWrapper
            label={parseContent(
              content[
                `content.${
                  isUpsell ? 'upsell' : 'new'
                }.contract.${portfolioKey}.suppl.title`
              ],
              {
                html: true,
                allowedTags: [],
                allowedAttributes: [],
              }
            )}
            desc={parseContent(
              content[
                `content.${
                  isUpsell ? 'upsell' : 'new'
                }.contract.${portfolioKey}.suppl.description`
              ],
              { html: true, allowedTags: [], allowedAttributes: [] }
            )}
            type={'supplementary-packages'}
          >
            {suppl.map((item) => (
              <PackageSuppl
                key={item.group}
                item={item}
                channels={
                  content[
                    `content.${
                      isUpsell ? 'upsell' : 'new'
                    }.contract.${portfolioKey}.${item.group}.channels`
                  ]
                    ? parseContent(
                        content[
                          `content.${
                            isUpsell ? 'upsell' : 'new'
                          }.contract.${portfolioKey}.${item.group}.channels`
                        ],
                        {
                          html: true,
                          allowedAttributes: ALLOWED_ATTRIBUTES,
                          allowedTags: ALLOWED_TAGS,
                        }
                      )
                    : null
                }
                toggleModal={() =>
                  toggleModal(
                    parseContent(
                      content[
                        `content.${
                          isUpsell ? 'upsell' : 'new'
                        }.contract.${portfolioKey}.${item.group}.description`
                      ],
                      {
                        html: true,
                        allowedTags: ALLOWED_TAGS,
                        allowedAttributes: ALLOWED_ATTRIBUTES,
                      }
                    )
                  )
                }
              >
                <Field
                  name={`package_suppl[${item.group}]`}
                  type="checkbox"
                  className={`list__input`}
                  component="input"
                  onClick={() => handleServices(item.group)}
                  disabled={item.disabled || item.active}
                  checked={item.selected}
                />
              </PackageSuppl>
            ))}
          </UpsellListWrapper>
        )}
        {portfolioKey !== 'TV_OTT' && (
          <div className={'portfolio'}>
            <h2 className="h2">
              {parseContent(
                content[`content.upsell.contract.portfolio.title`],
                {
                  html: true,
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
            </h2>
            <p className={'services__subtitle'}>
              {parseContent(
                content[
                  `content.${
                    isUpsell ? 'upsell' : 'new'
                  }.contract.${portfolioKey}.reception.description`
                ],
                {
                  html: true,
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
            </p>
            {/* <h2>
              {parseContent(
                content[`content.new.contract.${portfolioKey}.other.title`],
                {
                  html: true,
                  allowedTags: [],
                  allowedAttributes: [],
                }
              ) +
                parseContent(
                  content[
                    `content.new.contract.${portfolioKey}.other.title.modaltext`
                  ],
                  {
                    html: true,
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                ) +
                parseContent(
                  content[
                    `content.new.contract.${portfolioKey}.other.title.suffix`
                  ],
                  {
                    html: true,
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
            </h2>
            <p>
              {parseContent(
                content[
                  `content.new.contract.${portfolioKey}.other.description`
                ],
                {
                  html: true,
                  allowedTags: [],
                  allowedAttributes: [],
                }
              ) +
                ' ' +
                (
                  <u
                    onClick={toggleModal(
                      content[`content.new.contract.tellyapps.modal`]
                    )}
                  >
                    {}
                  </u>
                ) +
                parseContent(
                  content[
                    `content.new.contract.${portfolioKey}.other.description.suffix`
                  ],
                  {
                    html: true,
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
            </p> */}
            <PortfolioListWrapper
              label={sanitizeHtml(
                content[`content.new.contract.${portfolioKey}.other.title`],
                {
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
              desc={sanitizeHtml(
                content[
                  `content.new.contract.${portfolioKey}.other.description`
                ],
                {
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
              labelActionText={sanitizeHtml(
                content[
                  `content.new.contract.${portfolioKey}.other.title.modaltext`
                ],
                {
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
              labelTextAction={() =>
                toggleModal(content[`content.new.contract.tellyapps.modal`])
              }
              labelSuffix={sanitizeHtml(
                content[
                  `content.new.contract.${portfolioKey}.other.title.suffix`
                ],
                {
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
              descActionText={sanitizeHtml(
                content[
                  `content.new.contract.${portfolioKey}.other.description.modaltext`
                ],
                {
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
              descTextAction={() =>
                toggleModal(content[`content.new.contract.tellyapps.modal`])
              }
              descSuffix={sanitizeHtml(
                content[
                  `content.new.contract.${portfolioKey}.other.description.suffix`
                ],
                {
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
            />
            <div
              className={'portfolio__content'}
              style={{
                borderTop:
                  selectedPortfolio === undefined ? '1px solid #c8c8c8' : 0,
              }}
            >
              {other &&
                other.map((item) => (
                  <PackageOther
                    key={item.group}
                    item={item}
                    toggleModal={toggleModal}
                    modalContent={
                      item.group === 'MULTISCREEN' &&
                      content[
                        `content.${
                          isUpsell ? 'upsell' : 'new'
                        }.contract.tellyapps.modal`
                      ]
                    }
                  >
                    <Field
                      name={`package_other[${item.group}]`}
                      type="checkbox"
                      className={`list__input`}
                      component="input"
                      onClick={() => handleServices(item.group)}
                      disabled={
                        item.disabled || (item.required && item.selected)
                      }
                      checked={item.selected}
                      required={item.required}
                    />
                  </PackageOther>
                ))}
              <hr />
              <h3 className={'portfolio__content__text'}>
                {parseContent(
                  content[
                    `content.${
                      isUpsell ? 'upsell' : 'new'
                    }.contract.${portfolioKey}.devices.title`
                  ],
                  {
                    html: true,
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
              </h3>
              <p className={'portfolio__content__subtitle'}>
                {parseContent(
                  content[
                    `content.${
                      isUpsell ? 'upsell' : 'new'
                    }.contract.${portfolioKey}.devices.description`
                  ],
                  {
                    html: true,
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
              </p>
              {devices && (
                <React.Fragment>
                  <Field name="device_e" component={renderError} />
                  <DevicesWrapper
                    devices={devices}
                    deviceMax={option && option.deviceMax}
                    deviceMin={option && option.deviceMin}
                    toggleModal={toggleModal}
                    portfolioKey={portfolioKey}
                    content={content}
                    change={change}
                    values={formData.device}
                    isUpsell={true}
                  />
                </React.Fragment>
              )}
              {deviceTotal > 0 && (
                <React.Fragment>
                  <hr />
                  <h3 className={'portfolio__content__text'}>
                    {parseContent(
                      content[
                        `content.${
                          isUpsell ? 'upsell' : 'new'
                        }.contract.${portfolioKey}.installation.title`
                      ],
                      {
                        html: true,
                        allowedTags: [],
                        allowedAttributes: [],
                      }
                    )}
                  </h3>
                  <p
                    className={
                      'portfolio__content__subtitle portfolio__content__subtitle--warning'
                    }
                  >
                    {parseContent(
                      content[
                        `content.${
                          isUpsell ? 'upsell' : 'new'
                        }.contract.${portfolioKey}.installation.description`
                      ],
                      {
                        html: true,
                        allowedTags: [],
                        allowedAttributes: [],
                      }
                    )}
                  </p>
                  <div className={'instalation'}>
                    {installations &&
                      installations.map((item, i) => (
                        <div key={item.id} className={'instalation__item'}>
                          <label
                            htmlFor={`installation_type_${i}`}
                            className={'radio'}
                          >
                            <Field
                              type="radio"
                              id={`installation_type_${i}`}
                              name="installation_type"
                              component="input"
                              onClick={() => handleInstallation(item.id)}
                              checked={
                                selectedInstallation
                                  ? item.id === selectedInstallation
                                  : item.selected
                              }
                              disabled={item.disabled}
                            />
                            <span>
                              {item.name}
                              <span
                                className="portfolio__content__item__info"
                                onClick={(e) => {
                                  e.preventDefault()
                                  toggleModal(
                                    parseContent(
                                      content[
                                        `content.${
                                          isUpsell ? 'upsell' : 'new'
                                        }.contract.${portfolioKey}.installation.${
                                          item.id
                                        }.description`
                                      ],
                                      {
                                        html: true,
                                        allowedTags: ALLOWED_TAGS,
                                        allowedAttributes: ALLOWED_ATTRIBUTES,
                                      }
                                    )
                                  )
                                }}
                              >
                                ?
                              </span>
                            </span>
                          </label>
                          {/* <div className={'installation__item__price'}>
                          +&nbsp;
                          {formatCurrency(item.priceVat, 0)}
                        </div> */}
                        </div>
                      ))}
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
        <div className="footer--note small-note">
          {content[`content.account.services.new.legal.1`] && (
            <p
              dangerouslySetInnerHTML={{
                __html: content[`content.account.services.new.legal.1`],
              }}
            />
          )}

          {/* {content['content.account.services.${
                  isUpsell ? 'upsell' : 'new'
                }.legal.2'] && (
              <p
                dangerouslySetInnerHTML={{
                  __html: content['content.account.services.${
                  isUpsell ? 'upsell' : 'new'
                }.legal.2'],
                }}
              />
            )} */}
        </div>
        <div className="footline footline--activation footline--activation--1 footline--btn">
          <button
            disabled={submitting}
            className="btn btn--primary btn--wideboi"
            type="submit"
            // onClick={() => handleSubmitStep1()}
          >
            Pokračovat
          </button>
        </div>
      </form>
    )
  }
}

ServiceUpsellFormUpsell = reduxForm({
  form: 'service_upsell_form_u',
  touchOnBlur: false,
  //touchOnChange: false,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(ServiceUpsellFormUpsell)

export default ServiceUpsellFormUpsell
